module.exports = (__webpack_require__(3))(10);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/vue-router/dist/vue-router.min.js from dll-reference scripts
// module id = 14
// module chunks = 0